import React from 'react';
import PropTypes from 'prop-types';
import LoadableHOC from '../LoadableHOC';
import StatefulButton from '../formComponents/StatefulButton';

const LoadableStatefulButton = (props) => {
  const onChange = (name, value) => {
    props.onChange(name,
      value);
  };

  return (<StatefulButton {...props} onChange={onChange} />);
};

LoadableStatefulButton.PropTypes = {
  onChange:PropTypes.func,
};

export default LoadableHOC(LoadableStatefulButton);
